<template>
  <section-box v-if="!loading" class="mb-100 follow_up">
    <div class="follow_up--title flex flex-vertical-center flex-between">
      <span class="mr-50">In Automated Follow Up</span>

      <div class="flex">
        <button-link
          v-if="isPaused"
          @click="resumeFollowUp"
        >resume
        </button-link>
        <button-link
          v-if="isActive"
          @click="pauseFollowUp"
        >pause
        </button-link>
        <button-link
          @click="cancelFollowUp"
          class="ml-100"
        >cancel
        </button-link>
      </div>
    </div>

    <p class="follow_up--label">{{ followUpLabel }}</p>

    <p class="follow_up--step">
      <strong>Step {{ currentFollowUpStepCount }}/{{ totalFollowUpStepsCount }}</strong>
      <span v-if="isActive">{{ followUpStepString }}</span>
      <span v-if="isPaused">paused on {{ followUpPausedAt }}</span>
    </p>
  </section-box>
</template>

<script>
import {ENUMS} from "../../services/enums";
import dates from "../../services/dates";

export default {
  name: "RecordAutomatedFollowUpCard",
  props: {
    currentFollowUpId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      followUpSequence: null,
    };
  },
  computed: {
    isActive() {
      return this.followUpSequence.status === ENUMS.FollowUpSequenceStatusEnum.Active.value;
    },
    isPaused() {
      return this.followUpSequence.status === ENUMS.FollowUpSequenceStatusEnum.Paused.value;
    },
    isCancelled() {
      return this.followUpSequence.status === ENUMS.FollowUpSequenceStatusEnum.Canceled.value;
    },
    followUpPausedAt() {
      if (this.isPaused) {
        return dates.formatAsDate(this.followUpSequence.paused_at);
      }

      return null;
    },
    followUpLabel() {
      const template = this.$store.getters.fusTemplates.find(template => template.id === this.followUpSequence.FUS_template_id);

      if (template) {
        return template.label;
      }
    },
    followUpStepsInOrder() {
      let steps = this.followUpSequence.steps;
      return steps.sort((a, b) => new Date(a.due_at) - new Date(b.due_at));
    },
    currentFollowUp() {
      return this.followUpStepsInOrder.find(step => !step.is_complete);
    },
    currentFollowUpStepCount() {
      const indexOfCurrentStep = this.followUpStepsInOrder.findIndex(step => !step.is_complete);
      return indexOfCurrentStep + 1; // Adding 1 because index starts at 0
    },
    totalFollowUpStepsCount() {
      return this.followUpStepsInOrder.length;
    },
    followUpStepString() {
      if (this.currentFollowUp !== undefined) {
        const type = this.$utils.newGetEnumLabel(this.currentFollowUp.type, ENUMS.FollowUpSequenceStepTypeEnum);
        const date = dates.formatAsDate(this.currentFollowUp.due_at);
        const time = dates.formatAsTime(this.currentFollowUp.due_at);
        return type + " on " + date + " at " + time;
      }

      return  '';
    }
  },
  created() {
    this.$api.followUp.get(this.currentFollowUpId).then((response) => {
      this.followUpSequence = response.data;
      this.loading = false;
    });
  },
  methods: {
    pauseFollowUp() {
      this.isProcessing = true;

      this.$api.followUp.pause(this.currentFollowUpId).then(() => {
        this.$buefy.toast.open({message: "Paused Sequence", type: "is-success"});
      }).finally(() => {
        this.isProcessing = false;
      });
    },
    resumeFollowUp() {
      this.isProcessing = true;

      return this.$api.followUp.resume(this.currentFollowUpId).then(() => {
        this.$buefy.toast.open({message: "Resume Sequence", type: "is-success"});
      }).finally(() => {
        this.isProcessing = false;
      });
    },
    cancelFollowUp() {
      this.isProcessing = true;

      this.$api.followUp.cancel(this.currentFollowUpId).then(() => {
        this.$buefy.toast.open({message: "Cancelled Sequence", type: "is-success"});
      }).finally(() => {
        this.isProcessing = false;
      });
    },
  }
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

.follow_up {
  border-bottom: 4px solid $secondary;

  &--title {
    margin-bottom: 10px;
    font-size: 0.875rem;
    color: $text-muted;
  }

  &--label {
    font-size: 1.125rem;
  }

  &--step {
    margin-top: 8px;
    font-size: 0.75rem;
    color: $text-muted;

    strong {
      color: $text;
    }
  }
}
</style>
